import React from "react";
import { useParams, useLocation } from "react-router-dom";
import { englishNumbersToPersian } from "../../../core/utils/englishNumbersToPersian";
import { UseGetStatement } from "../../../core/services/api/get-statement";
import { FallBackSpinner } from "../../common/Spinner/FallBackSpinner/FallbackSpinner";
import EmptyPage from "../../common/EmptyPage/EmptyPage";
import "./StatementDetail.scss";

const StatementDetail = () => {
  const { id } = useParams();
  const location = useLocation();
  const manifestData = location?.state?.manifestData;
  const { data, isLoading } = UseGetStatement({
    page: 1,
    pageSize: 1,
    id,
    isActive: true,
  });

  if (isLoading) return <FallBackSpinner />;
  const statement = data?.data?.result?.statementList?.[0];
  if (!statement) {
    return <EmptyPage text="اطلاعات مورد نظر شما یافت نشد" />;
  }

  return (
    <div className="statement-detail-wrapper">
      <div className="statement-detail-image">
        <img
          src={`${process.env.REACT_APP_PUBLIC_PATH}/${manifestData?.imagePath}`}
          alt={manifestData?.title}
        />
      </div>

      <div className="statement-detail-info">
        <h1 className="statement-detail-title">{manifestData?.title}</h1>

        <div
          className="statement-detail-description"
          dangerouslySetInnerHTML={{
            __html: manifestData?.description,
          }}
        />

        <div className="statement-meta">
          <span>
            {statement?.statementCategories?.map((i) => i?.title)?.join(" / ")}
          </span>

          <span>
            {englishNumbersToPersian(statement?.publishedDateTimeAsJalali)}
          </span>
        </div>
      </div>
    </div>
  );
};

export { StatementDetail };
